/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HelpInputs */



/**
* | output |
* | --- |
* | "Help" |
*
* @param {HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const help = /** @type {((inputs?: HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Helfen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aiuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Помощь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ayuda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帮助")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ヘルプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मदद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajuda")
	return /** @type {LocalizedString} */ ("Help")
});